import * as React from 'react';

function SvgGoToPoker(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={55.541} height={55.541} {...props}>
      <g data-name="poker button">
        <path
          d="M47.651 29.469c.022 4.921-2.515 8.764-6.543 10.43a12.006 12.006 0 01-4.714.893 11.416 11.416 0 01-6.848-2.667 44.7 44.7 0 004.823 11.236 39.729 39.729 0 00-13.805.054 43.935 43.935 0 004.747-11.28 14.746 14.746 0 01-3.343 2.014 9.657 9.657 0 01-2.983.719 4.318 4.318 0 01-.534.011c-.065 0-.12-.011-.185-.011a3.747 3.747 0 01-.708-.044 11.368 11.368 0 01-3.266-.631c-.218-.087-.425-.152-.642-.25s-.435-.185-.631-.283a10.735 10.735 0 01-2.58-1.8c-.25-.229-.468-.468-.686-.708a28.4 28.4 0 01-.7-.882 11.843 11.843 0 01-1.971-6.641c0-.294.022-.61.011-.9a10.025 10.025 0 01.12-1.165 7.9 7.9 0 01.185-1.013 14.285 14.285 0 011.6-3.974c.131-.207.229-.392.359-.6s.261-.381.392-.577a24.812 24.812 0 012.1-2.613c.163-.185.316-.337.479-.5s.337-.348.512-.512c1.677-1.688 3.582-3.255 5.466-4.812a54.327 54.327 0 007.425-6.914 1.876 1.876 0 01.708-.533 1.942 1.942 0 01.7-.142l.109-.022a1.817 1.817 0 011.415.653 58.864 58.864 0 007.491 6.859c5.672 4.553 11.475 9.278 11.497 16.605z"
          fill="#7689b4"
        />
        <path
          d="M47.4 8.138A27.548 27.548 0 0027.771 0 27.548 27.548 0 008.138 8.137 27.614 27.614 0 00.001 27.77a27.548 27.548 0 008.137 19.633 27.633 27.633 0 0019.633 8.138A27.567 27.567 0 0047.4 47.4a27.633 27.633 0 008.138-19.633A27.567 27.567 0 0047.4 8.138zM27.767 51.96A24.21 24.21 0 013.578 27.771 24.21 24.21 0 0127.767 3.582a24.217 24.217 0 0124.189 24.189 24.21 24.21 0 01-24.185 24.188z"
          fill="#7689b4"
        />
        <text
          transform="translate(21.18 33.087)"
          fill="#182152"
          fontSize={21}
          fontFamily="Montserrat-Bold, Montserrat"
          fontWeight={700}
        >
          <tspan x={0} y={0}>
            {'P'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgGoToPoker;
